import axios from 'axios';
import {isPlainObject as _isPlainObject} from 'lodash';
// import {getAppLanguage} from "@/utils";
// import {vueInstanceI18n, vueInstanceStore} from "@/main";
// import {showError, showMessage} from "@/utils";


// eslint-disable-next-line no-unused-vars
const source = axios.CancelToken.source(); //need to cancel request
// const baseurl = 'https://api.sp-staging.info.pl/internal'

let widgetUserKey = null;
let widgetSource = null;

/* eslint-disable */
if(typeof SpMapWidget !== 'undefined'){
  widgetUserKey = SpMapWidget.getUserKey();
  widgetSource = SpMapWidget.getSource();
}
/* eslint-enable */

export const axiosInstance = axios.create({
  // baseURL: baseurl,
  headers: {
    'X-Language': window.APP_LANGUAGE ? window.APP_LANGUAGE : 'pl',
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'X-SP-Map-Widget-User-Key': widgetUserKey,
    'X-SP-Map-Widget-Source': widgetSource,
  },
});
axiosInstance.CancelToken = axios.CancelToken; //need to cancel request
axiosInstance.isCancel = axios.isCancel;

axiosInstance.interceptors.response.use((response) => {
    // Status code isn't a success code - throw error
    if (!`${ response.status }`.startsWith('2')) {
      throw response.data;
    }
    // Otherwise just return the data
    return response.data;
  },
  (error) => {
    // const errorCode = error.response?.status;
    // let errorMessage = null;

    if(axios.isCancel(error)) {
      throw error;
    }

    if (error && error.response) {
      if(_isPlainObject(error.response.data)) {
        // errorMessage = error.response.data?.error?.message;
      }
    }
      // showError(showMessage, errorCode, errorMessage, errorMessage);


    // if(errorCode === 401 || errorCode === 403) {
    //   vueInstanceStore.dispatch('auth/logout');
    // }

    // Pass the response from the API, rather than a status code
    if (error && error.response && error.response.data) {
      throw error.response.data;
    }
    throw error;
  },
);